// extracted by mini-css-extract-plugin
export default {"tableControls":"EditorContainer_tableControls__r0cpR","deleteButton":"EditorContainer_deleteButton__70mDf"};